export interface QualificationResponse {
  success?: boolean;
  code?: string;
  state?: string;
  operation_uuid?: string;
  work_order?: string;
  alternate_reference?: string;
  error?: string;
}

export interface QualificationNotice {
  kind: 'success' | 'pending' | 'error';
  message: string;
}

export function qualificationNotice(response: QualificationResponse | null | undefined): QualificationNotice {
  if (response?.success === true && response.code === '200' && response.state === 'applied' &&
      /^[0-9]{6}$/.test(response.work_order ?? '') &&
      /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(response.operation_uuid ?? '') &&
      response.alternate_reference === `${response.work_order}-01`) {
    return { kind: 'success', message: `Confirmed in UFOs: ${response.alternate_reference}.` };
  }
  if (response?.code === '202') {
    return { kind: 'pending', message: 'Qualification is pending. Check again to recover this same request; the order is not yet confirmed.' };
  }
  const errors: Record<string, string> = {
    transfer_shipper_address_required: 'Select and save the shipper address before qualifying.',
    transfer_consignee_address_required: 'Select and save the consignee address before qualifying.',
    selected_stop_address_required: 'Select and save both stop addresses before qualifying.',
    selected_stop_address_missing: 'The saved stop address is unavailable. Select and save the correct address.',
    transfer_lifecycle_protected: 'This order’s current status prevents qualification. Refresh and check its status.',
    forbidden: 'Your account does not have permission to qualify orders.',
    inactive_or_missing_transfer_contact: 'A saved contact is inactive or unavailable. Check the order’s contacts.',
    creation_disabled: 'Order qualification is temporarily unavailable. Try again later.',
    ams_changed_after_admission: 'The order changed during qualification. Its original request needs review.',
    ams_changed_after_native_commit: 'UFOs received the order, but AMS changed during qualification. Its link needs review.',
    native_created_reference_conflict: 'UFOs received the order, but its alternate reference needs review.',
    lading_owned_by_consolidation_creation: 'Use the consolidation workflow for this order.',
    lading_owned_by_shipment_creation: 'Use the split-shipment workflow for this order.',
    qualification_response_unconfirmed: 'Qualification was not confirmed. Check again to recover the same request before making another order.'
  };
  const error = response?.error ?? 'qualification_response_unconfirmed';
  return { kind: 'error', message: errors[error] ?? `Qualification needs attention (${error}). Check the saved order details and Roswell status.` };
}
